




































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import BillingSummary from '../../domain/billing/entity/billing-summary.entity';

@Component({ components: { VbTooltipSlot } })
export default class OverviewMainCardRowTable extends Vue {
  @Prop({
    required: true,
  })
  private item!: BillingSummary;

  @Prop({
    required: true,
  })
  private name!: string;

  @Prop({
    required: false,
    default: '0px',
  })
  private paddingLeft!: string;

  @Prop({
    required: false,
    default: '12px',
  })
  private fontSize!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  private hideValue!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  private disableLink!: boolean;

  private get value(): string {
    return this.hideValue ? '-' : VbDirectives.toCurrency(Number(this.item.value));
  }

  @Emit('click')
  private click() {}

  private statusColor(value: string): string {
    switch (value) {
      case 'PRE_BILLED':
      case 'TO_RECEIVE':
        return '#DCB02A';
      case 'BILLED':
        return '#2F80ED';
      case 'RECEIVED':
      case 'ACTIVE':
        return '#189F51';
      case 'DEFAULTING':
      case 'INACTIVE':
        return '#FF3306';
      default:
        return 'black';
    }
  }

  created() {
    this.getTooltipDescription('A Faturar');
  }

  getTooltipDescription(name: string) {
    const description = {
      Erro: 'Itens de contrato que apresentaram erro na execução do faturamento',
      'Faturamento desabilitado': 'Itens de contrato que estavam com suspensão de faturamento no momento da execução da rotina de faturamento',
      Negociação: 'Itens com suspensão de faturamento por motivo de negociação',
      'Em processamento': 'Itens de contrato que estão sendo faturados',
      'Não Faturados': 'Itens de contrato que apresentaram erros na execução do faturamento ou que estavam com suspenção de faturamento',
      'A Faturar': 'Itens de contrato ativos, de frequência mensal, que tem regras e instâncias aplicadas e que ainda não foram faturados para a competência escolhida na tela',
      'Pré-Faturados': 'Itens de contrato que foram pré faturados no Billing e ainda aguardam o faturamento no ERP',
      'Clientes sem consumo': 'Itens de Contrato que foram pré-faturados no Billing e que não registraram consumo ou quantidade para faturamento',
      'Demais clientes': 'Itens de Contrato que foram pré-faturados no billing e que ainda não foram faturados no ERP tendo valor maior que zero.',
      Faturados: 'Itens de contrato que foram faturados pelo Billing e tiveram emissão da Nota Fiscal no ERP.',
      'Descontos concedidos': 'Itens de Contrato que foram faturados no Billing e tiveram valor de Desconto Concedido',
      'A Receber': 'Itens de contrato que foram faturados, gerado nota fiscal e estão aguardando o recebimento',
      'Dentro do prazo': 'Itens de contrato que foram faturados, gerado nota fiscal e aguardam o recebimento dentro do prazo',
      Inadimplentes: 'Itens de contrato que foram faturados, gerado nota fiscal e o recebimento está em atraso',
      Recebidos: 'Itens de contrato que foram faturados, gerado nota fical e foram recebidos',
      'Com erro no pagamento': 'Erro ao tentar efetuar a cobrança na plataforma de pagamentos',
      'Com problema na integração do pagamento': 'O pagamento foi realizado com sucesso, mas não foi possível notificar o ERP',
    }
    if (description[name] == null) {
      return name
    }
    return description[name];
  }
}
